import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Typography, Button, Grid, Box, TableContainer, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ForecastAuditSingleRow from './ForecastAuditSingleRow';
import { presentFormatedData } from '../../functionalComponents/dataFormatFunctions';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    margin: '20px auto',
    padding: theme.spacing(2),
  },
  headerAuditText: {
      marginBottom: theme.spacing(2),
      textAlign: 'center',
      fontWeight:'500'
  },
  button: {
    backgroundColor: '#f5b7b1',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#f1948a',
    },
  },
  table: {
    marginTop: theme.spacing(2),
  },
  statusButton: {
    backgroundColor: '#58d68d',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#45b39d',
    },
  },
  approvedStatus: {
    backgroundColor: '#76d7c4',
    color: '#fff',
    borderRadius: '5px',
    padding: '5px 10px',
  },
  negotiationStatus: {
    backgroundColor: '#f7b7a3',
    color: '#fff',
    borderRadius: '5px',
    padding: '5px 10px',
  },
  headerTable: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#f8f9f9',
    borderRadius: '5px',
    padding: theme.spacing(2),
  },
  headerItem: {
    marginBottom: theme.spacing(1),
  },
  headerLabel: {
    fontWeight: 'bold',
    },
    headerContainer: {
        margin: '20px auto',
        padding: '16px',
        backgroundColor: '#f8f9fa',
      boxShadow: 'none',
        border:'0.5px solid #BEBEBEC7'
      },
      table: {
        width: '100%',
      },
      header: {
        fontWeight: '500',
        border:'none',
      },
      value: {
        fontSize: '14px',
          color: '#212529',
          border:'none',
      },
      status: {
        fontSize: '14px',
        borderRadius: '20px',
        padding: '4px 12px',
        textAlign: 'center',
        display: 'inline-block',
        whiteSpace: 'nowrap',
      },
}));

const ForecastAuditData = (props) => {
  const classes = useStyles();
  const { forecastAuditData, selectedFilterData } = props;
  // const [loading, setLoading]  = useState(true)
  // const [error, setError] = useState(false)
  
  

  // Sample data based on provided input
  // const data = {
  //   drugName: "TIOMATE (HFA) INHALER",
  //   drugID: "IMCL-986369",
  //   cdmoOrgName: "Recipharm",
  //   poNumber: "5100000670-50",
  //   initialSAPSyncDate: "10-AUG-2024",
  //   recentSAPSyncDate: "15-SEP-2024",
  //   latestStatus: "Schedule Approved",
  //   dsForecastScheduleAudit: [
  //     {
  //       lastUpdatedDate: "22/10/2024 17:30:00 (IST)",
  //       userName: "NA",
  //       role: "SAP",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Executed",
  //       eventDescription: "Sync with SAP, SAP Sync ID 9955648575",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "22/05/2024 11:50:00 (IST)",
  //       userName: "ken.kidd@immunocell.com",
  //       role: "Manager",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Approved",
  //       eventDescription: "Manager approves SAP Sync",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 22:34:40 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Sent for SAP Sync",
  //       eventDescription: "Planner sends the schedule for SAP Sync Approval",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 21:30:00 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Approved",
  //       eventDescription: "Manager approved the final schedule",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     },
  //     {
  //       lastUpdatedDate: "19/05/2024 17:30:00 (IST)",
  //       userName: "toni.levine@recipharm.com",
  //       role: "Project Manager",
  //       orgName: "Recipharm",
  //       event: "Schedule Sent for Approval",
  //       eventDescription: "Sponsor sends the schedule for approval",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     },
  //     {
  //       lastUpdatedDate: "22/10/2024 17:30:00 (IST)",
  //       userName: "NA",
  //       role: "SAP",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Executed",
  //       eventDescription: "Sync with SAP, SAP Sync ID 9955648575",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "22/05/2024 11:50:00 (IST)",
  //       userName: "ken.kidd@immunocell.com",
  //       role: "Manager",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Approved",
  //       eventDescription: "Manager approves SAP Sync",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 22:34:40 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Sent for SAP Sync",
  //       eventDescription: "Planner sends the schedule for SAP Sync Approval",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 21:30:00 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Approved",
  //       eventDescription: "Manager approved the final schedule",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     },
  //     {
  //       lastUpdatedDate: "19/05/2024 17:30:00 (IST)",
  //       userName: "toni.levine@recipharm.com",
  //       role: "Project Manager",
  //       orgName: "Recipharm",
  //       event: "Schedule Sent for Approval",
  //       eventDescription: "Sponsor sends the schedule for approval",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     },
  //     {
  //       lastUpdatedDate: "22/10/2024 17:30:00 (IST)",
  //       userName: "NA",
  //       role: "SAP",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Executed",
  //       eventDescription: "Sync with SAP, SAP Sync ID 9955648575",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "22/05/2024 11:50:00 (IST)",
  //       userName: "ken.kidd@immunocell.com",
  //       role: "Manager",
  //       orgName: "ImmunoCell",
  //       event: "SAP Sync Approved",
  //       eventDescription: "Manager approves SAP Sync",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 22:34:40 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Sent for SAP Sync",
  //       eventDescription: "Planner sends the schedule for SAP Sync Approval",
  //       forecastScheduleID: "90909272",
  //       status: "Schedule Approved"
  //     },
  //     {
  //       lastUpdatedDate: "21/05/2024 21:30:00 (IST)",
  //       userName: "maura.dyer@immunocell.com",
  //       role: "Planner",
  //       orgName: "ImmunoCell",
  //       event: "Schedule Approved",
  //       eventDescription: "Manager approved the final schedule",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     },
  //     {
  //       lastUpdatedDate: "19/05/2024 17:30:00 (IST)",
  //       userName: "toni.levine@recipharm.com",
  //       role: "Project Manager",
  //       orgName: "Recipharm",
  //       event: "Schedule Sent for Approval",
  //       eventDescription: "Sponsor sends the schedule for approval",
  //       forecastScheduleID: "94444895",
  //       status: "Schedule Under Negotiation"
  //     }
  //   ]
  // };

  // let auditData = useSelector((state) => {
  //   if (state.pcmp.common.Projects?.forecastAuditData?.status === true) {
  //     if (loading) {
  //       setLoading(false)
  //     }
  //     return state.pcmp.common.Projects.forecastAuditData.data
  //   } else if (state.pcmp.common.Projects?.forecastAuditData?.status === false) {
  //     if (loading) {
  //       setLoading(false)
  //     }
  //     if (error === '') {
  //     setError('Something went wrong. Please try again later.')
  //     }
  //     return {}
  //    }
  //   else {
  //     return {}
  //   }
  // })


  return (
    <Paper className={classes.container}>
      <Typography variant="h5" className={classes.headerAuditText}>
        Audit Report
      </Typography>
      {
//         loading ? <div style={{ width: '100%', textAlign: 'center' }}>
// <CircularProgress />
//       </div> : error ? <div style={{border: '2px solid #FF0000',
//                 backgroundColor: '#FFF0F0',}}>
//           <Typography>
//           Something went wrong. Please try again later.
//           </Typography>
//         </div>
//             :
        forecastAuditData && Object.keys(forecastAuditData).length >0 ?
          <React.Fragment>
          {/* Header Section */}
      <Paper className={classes.headerContainer}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align='left' className={classes.header}>Drug ID</TableCell>
            <TableCell align='left' className={classes.header}>Drug Name</TableCell>
                    {localStorage.collabType !== 'CMO' ?
                      <TableCell align='left' className={classes.header}>CMO</TableCell>
                      :
                      <TableCell align='left' className={classes.header}>Sponsor</TableCell>
                    }
            <TableCell align='left' className={classes.header}>
              {/* PO Details */}
              Forecast Details
            </TableCell>
            <TableCell align='left' className={classes.header}>Initial SAP Sync Date</TableCell>
            <TableCell align='left' className={classes.header}>Most Recent SAP Sync Date</TableCell>
            <TableCell align='center' className={classes.header}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align='left' style={{border:'none'}}>
              <Typography className={classes.value}>{presentFormatedData(forecastAuditData.drugID)}</Typography>
            </TableCell>
            <TableCell align='left' style={{border:'none'}}>
              <Typography className={classes.value}>{presentFormatedData(forecastAuditData.drugName)}</Typography>
            </TableCell>
            <TableCell align='left' style={{border:'none'}}>
                      {localStorage.collabType !== 'CMO' ?
                        <Typography className={classes.value}>{presentFormatedData(forecastAuditData.cdmoOrgName)}</Typography>
                        :
                        <Typography className={classes.value}>{presentFormatedData(forecastAuditData.sponsorOrgName)}</Typography>
                      }
            </TableCell>
            <TableCell align='left' style={{border:'none'}}>
              <Typography className={classes.value}>{forecastAuditData.poNumber ? `${forecastAuditData.poNumber} - ${forecastAuditData.poLineItemNumber}`: '-'}</Typography>
            </TableCell>
            <TableCell align='left' style={{border:'none'}}>
              <Typography className={classes.value}>{forecastAuditData.initialSAPSyncDate ? moment(forecastAuditData.initialSAPSyncDate).format('DD-MMM-YYYY').toUpperCase() : ' - '}</Typography>
            </TableCell>
            <TableCell align='left' style={{border:'none'}}>
              <Typography className={classes.value}>{forecastAuditData.recentSAPSyncDate ? moment(forecastAuditData.recentSAPSyncDate).format('DD-MMM-YYYY').toUpperCase() : ' - '}</Typography>
            </TableCell>
                          <TableCell align='center' style={{ border: 'none' }}>
                          <Box
      border={2} // Border thickness
      borderRadius={5} // Rounded corners
      borderColor="#A8D2E4" // Border color
      display="inline-block" // To make it shrink to content size
      px={3} // Horizontal padding
      py={0.5} // Vertical padding
    >
      <Typography
        variant="body1" // Adjust the size of the text
        style={{
          color: '#EC6535', // Text color
          fontWeight: '500', // Make the text bold
        }}
      >
        {presentFormatedData(forecastAuditData.latestStatus)}
      </Typography>
    </Box>
              {/* <Typography className={classes.status}>{data.latestStatus}</Typography> */}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
      {/* Audit Report Table */}
      <TableContainer style={{ maxHeight: 500 }}>
      <Table stickyHeader className={classes.table} >
        <TableHead >
                  <TableRow>
                  <TableCell style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight:'none'
          }}></TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
                borderRight: 'none',
            borderLeft:'none'
          }}>Date & Time</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Event</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Event Description</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Forecast Schedule ID</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Forecast Status</TableCell>
            <TableCell align='left'style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Organization</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderRight: 'none',
            borderLeft:'none'
          }}>Role</TableCell>
            <TableCell align='left' style={{
            background: '#FFE4CC',
                border: '2px solid #FFA95E',
            borderLeft:'none'
          }}>Username</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
                  {forecastAuditData.dsForecastScheduleAudit && forecastAuditData.dsForecastScheduleAudit.length > 0 ?  forecastAuditData.dsForecastScheduleAudit.map((row, index) => (
              <React.Fragment key={index}>
              <ForecastAuditSingleRow selectedFilterData={selectedFilterData} rowNo={index} row={row} listLength={forecastAuditData.dsForecastScheduleAudit.length} />
                    </React.Fragment>
          )):
                    <TableRow>
                      <TableCell colSpan={9} style={{textAlign:'center'}}>
                        No Records Found.
                      </TableCell>
        </TableRow>}
        </TableBody>
        </Table>
        </TableContainer>
        </React.Fragment> :
            <div >
        <Typography style={{textAlign:'center', border:'1px solid', padding:'2rem'}}>
        No Records Found.
        </Typography>
      </div>
    }
      
      
    </Paper>
  );
};

export default ForecastAuditData;
